import { render } from "./VideoAccount.vue?vue&type=template&id=e999a972&scoped=true"
import script from "./VideoAccount.vue?vue&type=script&lang=js"
export * from "./VideoAccount.vue?vue&type=script&lang=js"

import "./VideoAccount.vue?vue&type=style&index=0&id=e999a972&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e999a972"]])

export default __exports__